export type PetValueRangeSchema = { maxValue: string; id: number };

export type CatOrDog = 'dog' | 'cat';
export type PetTypeId = '1' | '2';
export type PetTypeSchema = { value: CatOrDog; id: PetTypeId };

export type PetSubTypeId = '1' | '2' | '3' | '4' | '5' | '6';
export type PetPedigree = 'pedigree' | 'crossed' | 'mixed';
export type PetSubTypeSchema = { type: CatOrDog; pedigree: PetPedigree; id: PetSubTypeId };

export type PetGender = 'male' | 'female';
export type PetGenderSchema = { gender: PetGender; isFemale: boolean };

export const MAX_PET_VALUE_NUMBER = 799;
export const MAX_PET_VALUE_RANGE = { maxValue: 'max', id: 17 };
export type PetValue =
  | '49'
  | '99'
  | '149'
  | '199'
  | '249'
  | '299'
  | '349'
  | '399'
  | '449'
  | '499'
  | '549'
  | '599'
  | '649'
  | '699'
  | '749'
  | '799'
  | 'max';
